import DB from "@/common/utils/db";

/**
 * @description 获取数据概览
 */

export function getList(query) {
    return DB({
        url: "m/partner/bd/listEnterprises",
        method: "get",
        params: query
    });
}

/**
 * @description 获取详情
 */

 export function getDetail(query) {
  return DB({
      url: "m/partner/bd/listPositions",
      method: "get",
      params: query
  });
}

/**
 * @description 获取数据概览
 */

 export function getTraceList(query) {
    return DB({
        url: "m/partner/bd/listCompanys",
        method: "get",
        params: query
    });
  }

/**
 * @description 获取详情
 */

 export function getTraceDetail(query) {
    return DB({
        url: "m/partner/bd/listHunters",
        method: "get",
        params: query
    });
  }